var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',_vm._g(_vm._b({staticClass:"ui-tabs",attrs:{"background-color":"transparent","grow":_vm.grow,"height":_vm.height}},'v-tabs',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.tabs),function(item){return _c('v-tab',{key:item.tab,staticClass:"black--text text--darken-1 px-6",class:_vm.tabSmall && 'v-tab-small',attrs:{"to":item.to || {
        name: _vm.$route.name,
        query: { ..._vm.$route.query, tab: item.tab },
        params: { ..._vm.$route.params },
      },"disabled":!!item.disabled,"exact":"","exact-active-class":"text--darken-6"}},[_vm._v(" "+_vm._s(item.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }